import { render, staticRenderFns } from "./iconCard.vue?vue&type=template&id=1eed8c24&scoped=true&"
import script from "./iconCard.vue?vue&type=script&lang=js&"
export * from "./iconCard.vue?vue&type=script&lang=js&"
import style0 from "./iconCard.vue?vue&type=style&index=0&id=1eed8c24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eed8c24",
  null
  
)

export default component.exports